export const CommitsRoutePath = '/:owner/:repo/pull/:pr_number/commits'
export const FilesRoutePath = '/:owner/:repo/pull/:pr_number/files'
